var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" "+_vm._s((_vm.row.current_stage && _vm.row.current_stage.current_negotiation ) ? _vm.$companyConfiguration.cardStageNegotiations.getNegotiationNameByType(_vm.row.current_stage.current_negotiation.type) : '')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }